import SearchResults, { SearchResultsProps } from "./SearchResults";

export interface SearchResultsInnerContainerProps {
    fetchMetadata: () => SearchResultsProps;
    className?: string;
    isSearch?: boolean;
}

/**
 * explore search-result reasons inner container
 */
export function SearchResultsInnerContainer({
    className,
    fetchMetadata,
    isSearch = false,
}: SearchResultsInnerContainerProps) {
    const info = fetchMetadata();

    return <SearchResults {...info} className={className} isSearch={isSearch} />;
}

export default SearchResultsInnerContainer;
